import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(
      private router: Router,
      private auth: AuthenticationService
    ) { }
  
     canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
         if (this.auth.isAuthenticated()) {
             return true;
         } else {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
            return false;
         }
     }

}



// WEBPACK FOOTER //
// C:/Users/egila/Downloads/temp/20260608_NuevoSAT/Trilce.Presentacion.Intranet.Profesores.NG5/src/app/support/services/auth-guard.service.ts